export const homeBanner = {
  title: "Unlocking the proteome",
  description: "Bridging new medicines with undruggable targets",
}